import { useEffect, useState } from 'react';

import { useWindowLocation } from '../../common/utils/use-window-location/useWindowLocation';

import { determinePageType } from './determinePageType';
import type { PageContextType } from './PageContextType';

export const usePageContextType = (): PageContextType => {
	const location = useWindowLocation();
	const [pageContextType, setPageContextType] = useState<PageContextType>(
		determinePageType(location),
	);

	useEffect(() => {
		setPageContextType(determinePageType(location));
	}, [location]);

	return pageContextType;
};
